export default "__VITE_ASSET__kmM$QphO__"